const SECRET_PHRASE = "Ingen1@r*urriesti";

const SECTION_ROLES = "roles";

const SECTION_SUCURSALES = "sucursales";

const SECTION_SETTINGS = "settings";

const SECTION_SEND_EMAIL = "send-email";

const SECTION_METRICS = "metrics";
const SECTION_USERS = "users";
const SECTION_EMPLOYEES = "employees";

const SECTION_WORKSECTORS = "worksectors";
const SECTION_WORKSTATIONS = "workstations";
const SECTION_LEGAJOS = "legajos";
const SECTION_FOLDERS = "folders";
const SECTION_DOCUMENT_LEGAJOS = "document-legajos";
const SECTION_SIGNINGS = "signings";
const SECTION_ORG_CHART = "org-chart";
const SECTION_ORG_CHART_NODE_TYPES = "org-chart-node-types";
const SECTION_PAYSLIPS = "payslips";
const SECTION_MY_PAYSLIPS = "my-payslips";
const SECTION_MY_ACCOUNT = "my-account";
const SECTION_NEWS = "news";

export default {
  SECRET_PHRASE: SECRET_PHRASE,

  SECTION_ROLES: SECTION_ROLES,
  SECTION_EMPLOYEES: SECTION_EMPLOYEES,


  SECTION_METRICS: SECTION_METRICS,
  SECTION_USERS: SECTION_USERS,
  SECTION_SETTINGS: SECTION_SETTINGS,

  SECTION_SUCURSALES: SECTION_SUCURSALES,
  SECTION_SEND_EMAIL:SECTION_SEND_EMAIL,
  SECTION_WORKSECTORS: SECTION_WORKSECTORS,
  SECTION_WORKSTATIONS: SECTION_WORKSTATIONS, 
  SECTION_LEGAJOS: SECTION_LEGAJOS,
  SECTION_FOLDERS: SECTION_FOLDERS,
  SECTION_DOCUMENT_LEGAJOS:SECTION_DOCUMENT_LEGAJOS,
  SECTION_SIGNINGS: SECTION_SIGNINGS,
  SECTION_ORG_CHART: SECTION_ORG_CHART,
  SECTION_ORG_CHART_NODE_TYPES: SECTION_ORG_CHART_NODE_TYPES,
  SECTION_PAYSLIPS: SECTION_PAYSLIPS,
  SECTION_MY_PAYSLIPS: SECTION_MY_PAYSLIPS,
  SECTION_MY_ACCOUNT: SECTION_MY_ACCOUNT,
  SECTION_NEWS: SECTION_NEWS,
};
